<template>
  <v-card class="mt-3" :outlined="resumeCardsOutlined">
    <v-card-title primary-title>
      <span class="headline">{{ $t('texts.education') }}</span>
      <v-spacer/>
      <v-btn
        color="primary" light
        :small="$vuetify.breakpoint.smAndUp"
        :fab="$vuetify.breakpoint.xsOnly"
        :to="{ name: 'employee.resume.education' }"
      >
        <template v-if="$vuetify.breakpoint.smAndUp">{{ $t('texts.addEducation') }}</template>
        <v-icon
          color="white"
          :right="$vuetify.breakpoint.smAndUp"
        >
          add
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-progress-linear v-if="fetchResumePending" height="2" :indeterminate="true"/>
    <v-card-text v-else class="pa-0">
      <v-list three-line class="py-0">
        <template v-for="(item, index) in items">
          <resume-education-item
            :item="item"
            :key="`education-${index}`"
          />
          <v-divider
            v-if="index + 1 < items.length"
            :key="`education-divider-${index}`"
          />
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import ResumeEducationItem from './ResumeEducationItem.vue';

export default {
  name: 'EmployeeResumeEducations',
  components: {
    ResumeEducationItem,
  },
  props: {
    fetchResumePending: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    resumeCardsOutlined: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
